export const calculatePercentage = (value: number, total: number) => {
    return (value / total) * 100;
};